<header *ngIf="schoolData" class="content__title">
  <h1><a class="link" (click)="getBackLink()">Back</a></h1>
  <br />
  <h1>{{ schoolData?.name }}</h1>
  <small>{{ schoolData?.city }}</small>
</header>
